/* eslint-disable react/prop-types */
import { Box, Button, Divider, Typography } from "@mui/material";
import NotificationItem from "./NotificationItem";

const NotificationPanel = ({
  notifications,
  loading,
  hasMore,
  onLoadMore,
  onMarkAllRead,
  onClearAll,
  onNotificationClick,
  onNotificationDelete,
}) => {
  return (
    <Box
      sx={{
        width: 360,
        maxWidth: "90vw",
        maxHeight: 480,
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "rgba(0,0,0,0.1)",
          borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0,0.3)",
          borderRadius: "3px",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.5)",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.5,
          gap: 1,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Notifications
        </Typography>
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Button size="small" onClick={onMarkAllRead}>
            Mark all as read
          </Button>
          <Button size="small" color="error" onClick={onClearAll}>
            Clear all
          </Button>
        </Box>
      </Box>
      <Divider />

      {notifications.length === 0 && !loading ? (
        <Box sx={{ px: 2, py: 3 }}>
          <Typography variant="body2" color="text.secondary">
            No notifications yet.
          </Typography>
        </Box>
      ) : (
        <Box sx={{ py: 0.5 }}>
          {notifications.map((item) => (
            <NotificationItem
              key={item.notification_id}
              notification={item}
              onClick={() => onNotificationClick(item)}
              onDelete={() => onNotificationDelete(item.notification_id)}
            />
          ))}
        </Box>
      )}

      {hasMore && (
        <Box sx={{ px: 2, pb: 1.5, pt: 1 }}>
          <Button
            size="small"
            variant="outlined"
            fullWidth
            disabled={loading}
            onClick={onLoadMore}
          >
            {loading ? "Loading..." : "Load more"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default NotificationPanel;
